import { store, getContext, getConfig } from "@wordpress/interactivity";

const NAMESPACE = "mgblocks/blog-archive";

const { state } = store(NAMESPACE, {
	state: {
		get numResults() {
			return state.posts.length > 0
				? `${state.posts.length} of ${state.totalCount} results`
				: "";
		},
	},
});
